module.exports = __webpack_public_path__ + "img/box-schliessen-weiss.4a409e5e.svg";